// Registry of available case studies. Only slugs listed here get a "Read case study" button.
// Full content is fetched lazily from /public/case-studies/<slug>.md when the window opens.
const caseStudies = [
  {
    slug: 'duration-tasks',
    title: 'Power Tools for Google Tasks',
    summary: 'A Chrome extension that lets you set time estimates on Google Tasks and see total durations at a glance.',
  },
  {
    slug: 'auth-hell',
    title: 'Authentication Hell',
    summary: 'An intentionally over-engineered authentication flow built to satirise modern auth UX.',
  },
  {
    slug: 'pokedex',
    title: 'Pokédex',
    summary: 'A feature-rich Pokédex with battle simulation, AI-powered advice, and gym prep tools.',
  },
];

export default caseStudies;

export const getCaseStudy = (slug) => caseStudies.find(cs => cs.slug === slug);
